import K1 from'../uprights/K1';import K1Wall from'../uprights/K1_wall';import K2 from'../uprights/K2';import Krossing from'../uprights/Krossing';export default{name:'uprights',computed:{configurator:function configurator(){return this.$store.state.configurator}},components:{k1uprights:K1,k1walluprights:K1Wall,k2uprights:K2,krossinguprights:Krossing}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/views/Uprights.vue
// module id = 288
// module chunks = 0